import React from 'react';
import { OkendoWidgetClient } from './OkendoWidget.client';
import { getOkendoProductId } from '../shared/productUtils';
import { widgetConfigurationError, widgetMetafieldError } from '../shared/errorUtils';
import { logger } from '../shared/logger';
export const OkendoClientStarRating = ({ productId, okendoStarRatingSnippet }) => {
    const okendoProductId = getOkendoProductId(productId);
    if (!okendoProductId) {
        logger.error(widgetConfigurationError('OkendoClientStarRating', 'productId was not provided'));
        return null;
    }
    if (!okendoStarRatingSnippet?.value) {
        logger.warn(widgetMetafieldError('OkendoStarRating', 'StarRatingSnippet'));
    }
    const dataAttributes = {
        'data-oke-star-rating': '',
        'data-oke-reviews-product-id': okendoProductId
    };
    if (okendoStarRatingSnippet?.value) {
        dataAttributes['data-oke-rendered'] = '';
    }
    return (React.createElement(OkendoWidgetClient, { dataAttributes: dataAttributes, metafieldContent: okendoStarRatingSnippet?.value }));
};
export default OkendoClientStarRating;
